// extracted by mini-css-extract-plugin
export var paginationContainer = "_63-0";